import { SB } from '@play-co/replicant';
import { match2DailyChallengeSchema } from './dailychallenge/match2-dailychallenge.schema';
import { tournamentSchema } from './tournament/match2-tournament.schema';
import { racesSchema } from './races/races.schema';
import { saveStateSchema } from './savestate/match2-savestate.schema';
import { shopBundlesSchema } from './shopbundles/match2-shopbundles.schema';
import { bundleSaleSchema } from './bundlesale/match2-bundlesale.schema';
import { battlePassSchema } from './battlepass/match2-battlepass.schema';
import { leaguesSchema } from './leagues/leagues.schema';
import { magicLampsSchema } from './magiclamps/magiclamps.schema';
import { regionsSchema } from './regions/regions.schema';
import { conversionSaleSchema } from '../conversionsale/conversionsale.schema';

const dailyRewardsCollectedSchema = {
  points: SB.int().default(0).min(0),
  gems: SB.int().default(0).min(0),
  energy: SB.int().default(0).min(0),
  moves: SB.int().default(0).min(0),
  boosters: SB.map(SB.number().min(0).default(0)),
  powerups: SB.map(SB.number().min(0).default(0)),
};

const dailyBonusSchema = {
  nextBonusTimestamp: SB.int().default(0).min(0),
  dailyCount: SB.int().default(0).min(0),
  totalCount: SB.int().default(0).min(0),
  dailyRewardsCollected: SB.object(dailyRewardsCollectedSchema),
  totalRewardsCollected: SB.object(dailyRewardsCollectedSchema),

  // For tracking daily stats
  currentDayStamp: SB.int(),
};

const frenzySchema = {
  activeId: SB.string(),
  progress: SB.int().default(0).min(0),
  unclaimedMilestone: SB.array(SB.int().min(0)),
};

// state (moved from Kaito's codebase)
//-----------------------------------------------------------------------------
export const match2Schema = {
  match2: SB.object({
    // whether or not the player is currently playing the game
    playing: SB.boolean().optional(),
    // current level
    level: SB.int().default(1),
    // highest completed level
    lastLevel: SB.int().default(0),

    // start timestamp
    time: SB.int(),
    // continue counter
    continues: SB.int(),
    // tutorial complete
    tutorialComplete: SB.boolean().default(false),
    // boosters in inventory
    boosters: SB.object({
      dart: SB.number().min(0).default(3),
      bullet: SB.number().min(0).default(3),
      drill: SB.number().min(0).default(3),
      roulette: SB.number().min(0).default(3),
    }),
    // powerups in inventory
    powerups: SB.object({
      rocket: SB.number().min(0).default(3),
      bomb: SB.number().min(0).default(3),
      cube: SB.number().min(0).default(3),
    }),
    // misc in inventory
    inventory: SB.object({
      // Free continues
      extraMoves: SB.number().min(0).default(0),
    }),
    // tips completion
    tips: SB.map(SB.boolean()).default({}),
    // daily bonus related
    dailyBonus: SB.object(dailyBonusSchema),
    // win streak
    winStreak: SB.int().default(0),
    // frenzy related
    frenzy: SB.object(frenzySchema),
    // Timestamp map that can be used by multiple features
    timestamps: SB.map(SB.int()).optional(),
    // Ongoing timed rewards
    ongoingTimedRewards: SB.map(
      SB.object({
        // timestamp when the reward was started
        startTime: SB.int(),
        // level where it was unlocked
        levelStarted: SB.int(),
        // number of used items
        usedItems: SB.int(),
        // whether or not has been marked as expired (and recorded in analytics)
        expired: SB.boolean(),
      }),
    ).optional(),
    // Match2 tournaments
    tournament: SB.object(tournamentSchema),
    // Daily challenges
    dailyChallenge: SB.object(match2DailyChallengeSchema).optional(),
    // losing streak that resets on win
    losingStreak: SB.int().default(0),
    // Mark if the player has used continue last match
    usedContinueLastMatch: SB.boolean().optional(),

    // Race
    ...racesSchema,

    // Rubberbanding ladder
    winLadderStep: SB.int().default(1),

    // Buru streak state.
    buruStreak: SB.object({
      value: SB.int().default(0),
      // Identifies the current run in analytics; bumped on every reset so IDs are never reused.
      id: SB.int().default(0),
    }),

    // Saved puzzle gameplay state
    ...saveStateSchema,

    // Shop bundles state
    ...shopBundlesSchema,

    // Bundle sale state
    ...bundleSaleSchema,

    // League
    ...leaguesSchema,

    // Magic lamps schema
    ...magicLampsSchema,

    // Battle pass state
    ...battlePassSchema,

    // Regions schema
    ...regionsSchema,

    // COnversion sale schema
    ...conversionSaleSchema,
  }),
};
